module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "buy-box-dashboard-page"
  }, [_c('BuyBoxDashboard')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0b4cd658!./~/vue-loader/lib/selector.js?type=template&index=0!./src/BuyBoxDashboardPage.vue
// module id = 721
// module chunks = 2